import { NavDropdownContentProps, NavItem } from "../NavHeader.type";

export function isPopulatedNavItem(item: unknown): item is NavItem {
    if (!item) return false;
    const { title, link } = item as NavItem;
    return !!(title && link);
}

export function isPopulatedNavDropdown(item: unknown): item is NavDropdownContentProps {
    if (!item) return false;
    const { label, itemListSection, ctaSection, tileSection } = item as NavDropdownContentProps;
    return !!(label && itemListSection?.length && ctaSection?.text && tileSection);
}